import { useConfig } from './eliot-components/src/ConfigProvider/hooks';
import { useAppDispatch as useAppStateDispatch, useAppState } from './common';
import { useEffect } from 'react';
import { fetchWithAuth } from './fetch';
import { AppDispatch, RootState } from './store';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const useApiData = () => {
  const { apiBaseURL } = useConfig();

  return (path: string, params: { [id: string]: string } = {}) => {
    const query = Object.keys(params)
      .map((key) => key + '=' + params[key])
      .join('&');

    return fetchWithAuth(apiBaseURL + path + (query ? `?${query}` : ''), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
  };
};

/* istanbul ignore next */
const useUpdateDeviceStateQueue = () => {
  const { selectedOrgs, updateDeviceQueue } = useAppState();
  const fetchFn = useApiData();
  const dispatch = useAppStateDispatch();

  useEffect(() => {
    if (selectedOrgs && selectedOrgs.length > 0) {
      const refresh = () => {
        const promises = selectedOrgs.map((org) =>
          fetchFn(
            `/v1/orgs/${org.id}/jobs/change-devices-state?status=pending&status=running`
          )
        );
        Promise.all(promises).then(async (responses: Response[]) => {
          let queue: { [id: string]: string } = {};

          const jobs = responses.map(async (response) => {
            const data = await response.json();
            data.jobs.forEach((job: any) => {
              if (job.status !== 'done') {
                job.deviceStateChanges.forEach((device: any) => {
                  queue[device.deviceID] = device.newState;
                });
              }
            });
          });
          await Promise.all(jobs);
          dispatch('device-status-changed', queue);
        });
      };

      if (!updateDeviceQueue) {
        refresh();
      }

      const id = setInterval(refresh, 30000);

      return () => {
        clearInterval(id);
      };
    }
  });
};

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export {
  useUpdateDeviceStateQueue,
  useApiData,
  useAppDispatch,
  useAppSelector,
};
